import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const PartnerAgentOwnerMarketingPageFooter = ({
  partner,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrBox
      boxSizing='border-box'
      width='100%'
      paddingTop={isSmallScreen ? '162px' : '188px'}
      paddingBottom='180px'
    >
      <SrBox>
        {partner.logoUrl && (
          <img
            src={partner.logoUrl}
            alt='partner logo'
            height='87px'
            style={{ margin: '0 auto', display: 'block' }}
          />
        )}
      </SrBox>
      <SrBox maxWidth='550px' margin='48px auto 0'>
        <SrText
          size={isSmallScreen ? '32' : '48'}
          color='black'
          weight='700'
          align='center'
          font='greycliff'
          lineHeight={isSmallScreen ? '38px' : '58px'}
          display='block'
        >
          I'm excited to help you lease your property!
        </SrText>
      </SrBox>
      <SrBox marginTop={isSmallScreen ? '30px' : '24px'}>
        <SrText
          size='18'
          color='grey500'
          weight='400'
          align='center'
          font='greycliff'
          lineHeight='24px'
          display='block'
        >
          Please contact me when you're ready to get your property listed on the market
        </SrText>
      </SrBox>
      <SrBox marginTop={isSmallScreen ? '22px' : '44px'}>
        <SrText
          size={isSmallScreen ? '16' : '24'}
          color='black'
          weight='600'
          align='center'
          font='greycliff'
          lineHeight='24px'
          display='block'
        >
          {partner.displayName}
        </SrText>
      </SrBox>
      <SrBox marginTop='162px'>
        <SrText
          size='18'
          color='grey500'
          weight='400'
          align='center'
          font='greycliff'
          lineHeight='24px'
          display='block'
        >
          Powered by:
        </SrText>
      </SrBox>
      <SrBox marginTop='32px' />
      <img
        src='/images/sunroom-logo-footer.svg'
        alt='sunroom logo'
        height='64px'
        style={{ margin: '0 auto', display: 'block' }}
      />
    </SrBox>
  );
};

PartnerAgentOwnerMarketingPageFooter.propTypes = {
  partner: PropTypes.object.isRequired,
};

PartnerAgentOwnerMarketingPageFooter.displayName = 'PartnerAgentOwnerMarketingPageFooter';

export default PartnerAgentOwnerMarketingPageFooter;
